// Placeholder blog images
// Replace these with actual blog images

// For now, we'll use a color-based placeholder approach
// You can replace these paths with actual images later

export const blogImages = {
  blog1: 'https://media.assettype.com/freepressjournal/2025-09-27/u6dtgo06/Info-edge-jeevansathi-naukri.jpg', // Startup/Innovation
  blog2: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop', // Finance/Funding
  blog3: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6lcbLrydZi6OBAPkSvvSGwZOreWIVFfhiSQ&s', // Product Development
  blog4: 'https://images.yourstory.com/cs/2/220356402d6d11e9aa979329348d4c3e/venture-debt-1623172478208.png?mode=crop&crop=faces&ar=2%3A1&format=auto&w=1920&q=75',
  blog5: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTiyrVSdsLo67K9OjaXoK6PjRRT1zeRMUaIxQ&shttps://palletcentralent.com/wp-content/uploads/2025/09/Pallet-Storage-Hacks.jpg', // Marketing
  blog6: 'https://sgtuniversity.ac.in/assets/images/faculty/law/blogs/Unlocking-the-Tapestry-of-Legal-Pursuits.webp', // Investment/Pitch
};
